import { urlValidator } from './url';
export var getUrlSegmentsValidators = function (_a) {
    var url = _a.url;
    return [urlValidator(url)].find(Boolean);
};
//# sourceMappingURL=get-url-segments-validators.js.map